import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormTitleProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IFormTitleProps>>
): IComponentSchema<IFormTitleProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Form Title',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.FormTitle,
    'x-component-props': {
      title: 'Title',
    },
    'x-component-props-config': {},
  };
};
